import * as React from 'react';
type Props = {
  className?: string;
};
export function NoTomatoes({ className }: Props) {
  return (
    <svg
      viewBox="0 0 61 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-NoTomatoes"
      className={className}
    >
      <g clipPath="url(#clip0_146_843)">
        <path
          d="M30.675 19.6962C29.0161 19.8247 25.8619 17.8154 23.397 17.2313C21.2354 16.7965 18.993 17.0204 16.9601 17.8739C14.7551 18.7168 12.8696 20.2292 11.5684 22.1988C10.2672 24.1684 9.61571 26.4962 9.70543 28.8551C9.91104 31.1243 10.5726 33.3287 11.6506 35.3361C12.7285 37.3434 14.2009 39.1125 15.9789 40.5373C21.8201 45.2102 30.8271 45.6659 37.9182 44.1472C44.5537 42.722 49.2264 38.4697 50.8503 32.1729C51.6718 29.0573 51.3827 25.7528 50.0326 22.8271C49.3011 21.2669 48.2068 19.9043 46.841 18.8536C45.4753 17.8028 43.8777 17.0944 42.1821 16.7874C40.1151 16.3566 37.9655 16.5728 36.0256 17.4066C34.2265 18.1659 32.2988 19.8247 30.675 19.6962Z"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M21.2593 21.5888H40.7686"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M25.8154 26.8224L31.014 21.5888V15.0934"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M36.2128 26.8224L31.0142 21.5888V15.0934"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M11.7852 52.4533L19.6356 42.8972"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M1.08399 30.0001C1.08168 24.1817 2.80497 18.4931 6.03582 13.6542C9.26667 8.81524 13.86 5.0431 19.2348 2.81489C24.6097 0.586682 30.5245 0.00258373 36.2314 1.13628C41.9383 2.26998 47.1809 5.07066 51.296 9.18408C55.411 13.2975 58.2135 18.5388 59.3495 24.2452C60.4854 29.9517 59.9036 35.8669 57.6776 41.2427C55.4515 46.6184 51.6812 51.2132 46.8435 54.4459C42.0059 57.6787 36.3182 59.4042 30.4998 59.4042C22.7002 59.4042 15.2198 56.3067 9.70363 50.7927C4.18742 45.2786 1.08708 37.7996 1.08399 30.0001"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M41.6914 16.6238L49.2148 7.58179"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
      </g>
      <defs>
        <clipPath id="clip0_146_843">
          <rect
            width={60}
            height={60}
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
